import React, { useState } from 'react';

interface ChatComposerProps {
  disabled: boolean;
  onSend(content: string): void;
}

const ChatComposer: React.FC<ChatComposerProps> = ({ disabled, onSend }) => {
  const [draft, setDraft] = useState('');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (disabled || !draft.trim()) return;
    onSend(draft);
    setDraft('');
  };

  // A form rather than an input + click handler so Enter-to-send is native.
  return (
    <form className="chat-input-container" onSubmit={submit}>
      <input
        type="text"
        className="chat-input"
        placeholder={disabled ? 'Chat has ended' : 'Type a message...'}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        disabled={disabled}
        aria-label="Message"
      />
      <button type="submit" className="chat-send-btn" disabled={disabled || !draft.trim()}>
        Send
      </button>
    </form>
  );
};

export default ChatComposer;
